<!-- @format -->

<div
	class="hmf-global-chips-container"
	[ngClass]="visibleFilter ? 'visible-filter' : ''"
	(click)="toggleFilter()">
	<div
		class="global-chip hmf-body-bold-m hmf-body-m hmf-px-xs hmf-py-xxxs"
		tabindex="0"
		[ngClass]="isSelected ? 'global-chips--active' : ''">
		{{ label }}
		<!-- dispaly selected delivery zipcode or store location in the filter chip -->
		@if (shouldShowLocation) {
			<span class="hmf-px-xxxs">{{ label === 'Pickup' ? 'at' : 'to' }}</span>
		}
		@if (shouldShowLocation) {
			<span>{{
				(label === 'Pickup' ? selectedStoreName : selectUserZipCode) | titlecase
			}}</span>
		}
		@if (showCancelSign) {
			<span class="hmf-pl-xs">
				<homefield-icon
					class="hmf-global-chip-svg"
					width="20px"
					height="20px"
					name="sign-cancel-outline"></homefield-icon>
			</span>
		}
	</div>
</div>
